import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';
import lookupValidator from 'ember-changeset-validations';
import Changeset from 'ember-changeset';
import { validatePresence } from 'ember-changeset-validations/validators';

const addGroupValidation = {
  name: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Add Group');
  },

  model() {
    let changeset = new Changeset(
      {},
      lookupValidator(addGroupValidation),
      addGroupValidation,
    );
    return {
      changeset,
    };
  },
});
